import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { QuestionTypes } from "../../static/enums/Questions";

interface UseResetAnswerFields<T = string> {
	prefix?: string;
	defaultAnswerConfig: string | null | Array<T>;
	defaultCorrectAnswer: string | null | Array<T>;
	defaultQuestionType: QuestionTypes;
	forceReset?: boolean;
}

export function useResetAnswerFields({
	prefix = "",
	defaultAnswerConfig,
	defaultCorrectAnswer,
	defaultQuestionType,
	forceReset = false,
}: UseResetAnswerFields) {
	const { formState, setValue, resetField } = useFormContext();

	useEffect(() => {
		const classIsDirty = `${prefix}class`.split(".").reduce<any>((acc, value) => {
			if (acc === false) return acc;
			acc = acc[value];
			if (acc === undefined) return false;
			return acc;
		}, formState.dirtyFields);

		if (classIsDirty || forceReset) {
			resetField(`${prefix}correct_answer`, {
				defaultValue: defaultCorrectAnswer,
			});
			resetField(`${prefix}answer_config`, {
				defaultValue: defaultAnswerConfig,
			});
			setValue(`${prefix}correct_answer`, defaultCorrectAnswer);
			setValue(`${prefix}answer_config`, defaultAnswerConfig);
			resetField(`${prefix}class`, {
				keepDirty: true,
				defaultValue: defaultQuestionType,
			});
		}
	}, []);
}
